import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Subscribe = () => {
   useEffect(() => {
    document.title = "Subscribe | Oriflamme IT Solutions";
  }, []);
  
  const [subscribers, setSubscribers] = useState([]);
  const [filteredSubscribers, setFilteredSubscribers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

 useEffect(() => {
  fetch("http://127.0.0.1:8000/api/show-subscriber", {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if (res.status === 401) {
        navigate("/login");
        return null;
      }

      if (!res.ok) {
        throw new Error("Failed to fetch subscribers");
      }

      return res.json();
    })
    .then((data) => {
      if (!data) return;

      const list = data.data || [];
      const sortedList = list.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setSubscribers(sortedList);
      setFilteredSubscribers(sortedList);
    })
    .catch((err) => {
      setError(err.message);
      setSubscribers([]);
    })
    .finally(() => setLoading(false));
}, [navigate]);

  useEffect(() => {
    const filtered = subscribers.filter((item) =>
      [item.email, item.is_active ? "Subscribe" : "Unsubscribe"]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredSubscribers(filtered);
  }, [search, subscribers]);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredSubscribers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscribers");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "Subscribers.xlsx");
  };

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => index + 1,
      width: "70px",
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    {
      name: "Status",
      selector: (row) => (row.is_active ? "Subscribe" : "Unsubscribe"),
      sortable: true,
    },
    {
      name: "Subscribed At",
      selector: (row) =>
        new Date(row.created_at).toLocaleDateString("en-GB"),
      sortable: true,
    },
  ];

  return (
    <div className="container mt-3">
      {loading && <div className="alert alert-info">Loading...</div>}
      {error && <div className="alert alert-danger">Error: {error}</div>}

      <div className="d-flex justify-content-between align-items-center mb-2">
        <input
          type="text"
          placeholder="Search by email or status..."
          className="form-control w-50"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="btn btn-success ms-2" onClick={exportToExcel}>
          Export to Excel
        </button>
      </div>

      <DataTable
        columns={columns}
        data={filteredSubscribers}
        pagination
        highlightOnHover
        striped
        responsive
      />
    </div>
  );
};

export default Subscribe;
